import React, { useState } from 'react';

function TrackingControls({ onTrack }) {
    const [vehicleId, setVehicleId] = useState('V123');

    const handleTrack = () => {
        if (!vehicleId) {
            alert('Enter a vehicle ID');
            return;
        }
        onTrack(vehicleId);
    };

    return (
        <div>
            <h3>Tracking Mode</h3>
            <input value={vehicleId} onChange={e => setVehicleId(e.target.value)} placeholder="Track Vehicle ID" />
            <button onClick={handleTrack}>Track Vehicle</button>
        </div>
    );
}

export default TrackingControls; 